// 消息通知
import http from "@/jslibs/axios/http";

// 消息列表
export const page = (data) => http.post("/web/msgManager/getSysNoticeList", data);

// 新增消息通知
export const add = (data) => http.post("/web/msgManager/addSysNotice", data);

// 删除
export const del = (data) => http.post("/web/msgManager/deleteSysNotice", data);
